<template>
  <v-layout row wrap fill-height align-center justify-center class="py-5">
    <v-flex xs12 sm10 md10 lg8 xl6>
      <v-card>
        <v-card-text class="pa-4">
          <h2 class="display-1 mb-4" v-text="selectedService.title"></h2>
          <div class="mb-4" v-if="isSluzbaAkce" v-html="selectedService.popis"></div>
          <v-form v-model="valid" ref="form" validate>
            <!--<div class="multi-day-rezervation-change" v-text="multiDayReyervationSwapButtonText" @click="multiDayRezervationChange"></div>-->
            <v-layout v-if="getMultiDayRezervation" row wrap>
              <v-flex xs12 sm6 class="pr-2">
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.datumKonani"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Datum konání od"
                    v-model="dateFromFormatedOutput"
                    prepend-icon="event"
                    readonly
                    :rules="[requiredRulle, v => checkDateFrom(v) || 'Datum nesmí být v minulosti']"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-date-picker-override
                    v-model="order.datumKonani"
                    scrollable
                    :header-date-format="formatSubHeaderDate"
                    :title-date-format="formatHeaderDate"
                    :month-format="formatMonths"
                    locale="cs_CZ"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal1 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog1.save(order.datumKonani);refreshSkladoveZasoby()">Potvrdit
                    </v-btn>
                  </v-date-picker-override>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6 class="pl-2">
                <v-dialog
                  ref="dialog2"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.konaniOd"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Od"
                    v-model="order.konaniOd"
                    prepend-icon="access_time"
                    readonly
                    :rules="[requiredRulle, checkTimeFrom]"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-time-picker-override v-model="order.konaniOd" format="24hr" :allowed-hours="getAllowedHours"
                                          :allowed-minutes="getAllowedMinutes" actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal2 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog2.save(order.konaniOd);refreshSkladoveZasoby()">Potvrdit
                    </v-btn>
                  </v-time-picker-override>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-layout v-if="getMultiDayRezervation" row wrap>
              <v-flex xs12 sm6 class="pr-2">
                <v-dialog
                  ref="dialog3"
                  persistent
                  v-model="modal3"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.datumKonaniDo"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Datum konání do"
                    v-model="dateToFormatedOutput"
                    prepend-icon="event"
                    readonly
                    :rules="[requiredRulle, v => checkDateTo(v) || 'Datum nesmí být v minulosti']"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-date-picker-override
                    v-model="order.datumKonaniDo"
                    scrollable
                    :header-date-format="formatSubHeaderDate"
                    :title-date-format="formatHeaderDate"
                    :month-format="formatMonths"
                    locale="cs_CZ"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal3 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog3.save(order.datumKonaniDo);refreshSkladoveZasoby()">
                      Potvrdit
                    </v-btn>
                  </v-date-picker-override>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6 class="pl-2">
                <v-dialog
                  ref="dialog4"
                  persistent
                  v-model="modal4"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.konaniDo"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Do"
                    v-model="order.konaniDo"
                    prepend-icon="access_time"
                    readonly
                    :rules="[requiredRulle, checkTimeTo]"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-time-picker-override v-model="order.konaniDo" :allowed-hours="getAllowedHours" format="24hr"
                                          actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal4 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog4.save(order.konaniDo);refreshSkladoveZasoby()">Potvrdit
                    </v-btn>
                  </v-time-picker-override>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-layout v-if="!getMultiDayRezervation" row wrap>
              <v-flex xs12 sm12 class="pr-2">
                <v-dialog
                  ref="dialog1"
                  persistent
                  v-model="modal1"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.datumKonani"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Datum konání"
                    v-model="dateFromFormatedOutput"
                    prepend-icon="event"
                    readonly
                    :rules="[requiredRulle, v => checkDateFrom(v) || 'Datum nesmí být v minulosti']"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-date-picker-override
                    v-model="order.datumKonani"
                    scrollable
                    :header-date-format="formatSubHeaderDate"
                    :title-date-format="formatHeaderDate"
                    :month-format="formatMonths"
                    locale="cs_CZ"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal1 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog1.save(order.datumKonani);order.datumKonaniDo = order.datumKonani;refreshSkladoveZasoby()">
                      Potvrdit
                    </v-btn>
                  </v-date-picker-override>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-layout v-if="!getMultiDayRezervation" row wrap>
              <v-flex xs12 sm6 class="pr-2">
                <v-dialog
                  ref="dialog2"
                  persistent
                  v-model="modal2"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.konaniOd"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Od"
                    v-model="order.konaniOd"
                    prepend-icon="access_time"
                    readonly
                    :rules="[requiredRulle, checkTimeFrom]"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-time-picker-override v-model="order.konaniOd" format="24hr" :allowed-hours="getAllowedHours"
                                          :allowed-minutes="getAllowedMinutes" actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal2 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog2.save(order.konaniOd);refreshSkladoveZasoby()">Potvrdit
                    </v-btn>
                  </v-time-picker-override>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6 class="pl-2">
                <v-dialog
                  ref="dialog4"
                  persistent
                  v-model="modal4"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.konaniDo"
                  :disabled="isSluzbaAkce"
                >
                  <v-text-field
                    slot="activator"
                    label="Do"
                    v-model="order.konaniDo"
                    prepend-icon="access_time"
                    readonly
                    :rules="[requiredRulle, checkTimeTo]"
                    required
                    :disabled="isSluzbaAkce"
                    @input="refreshSkladoveZasoby"
                  ></v-text-field>
                  <v-time-picker-override v-model="order.konaniDo" :allowed-hours="getAllowedHours" format="24hr"
                                          actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal4 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog4.save(order.konaniDo);refreshSkladoveZasoby()">Potvrdit
                    </v-btn>
                  </v-time-picker-override>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-checkbox v-if="!this.isSluzbaAkce" v-model="multiDayRezervation" color="primary"
                        label="Objednávám na více dní" value="Objednávám na více dní"></v-checkbox>
            <v-text-field v-if="isSluzbaAkce"
                          label="Start"
                          v-model="order.mistoVyzvednuti"
                          required
                          :rules="[requiredRulle]"
                          disabled
            ></v-text-field>
            <v-text-field v-if="isSluzbaAkce"
                          label="Cíl"
                          v-model="order.mistoOdevzdani"
                          required
                          :rules="[requiredRulle]"
                          disabled
            ></v-text-field>

            <v-select
              v-if="!isSluzbaAkce"
              color="primary"
              label="Start"
              v-model="order.mistoVyzvednuti"
              required
              :rules="[requiredRulle]"
              :items="getPobockyOptions"
            ></v-select>
            <v-select
              v-if="!isSluzbaAkce"
              color="primary"
              label="Cíl"
              v-model="order.mistoOdevzdani"
              required
              :rules="[requiredRulle]"
              :items="getPobockyOptions"
            ></v-select>

            <v-text-field
              label="Počet paddleboardů"
              v-model="order.pocetPrken"
              required
              :rules="[requiredRulle, v => checkPadlleboradStore(v) || 'Omlouváme se, ale tolik prken na tuto dobu již nemáme :-)', v => Number(v) >= 0 || 'Počet objednaných prken nesmí být záporný']"
              :suffix="cenaZaPrkna | formatPrice"
              mask="###"
              :disabled="!isDateValid"
            ></v-text-field>
            <!--<p v-if="isDateValid">Cena za jedno prkno {{ cenaZaPrkno }}</p>-->
            <!--<p v-if="isDateValid">Zbývající Počet paddleboardů: {{ volnaMista - order.pocetPrken }}</p>-->
            <v-text-field
              v-if="!isSluzbaAkce && !getMultiDayRezervation"
              label='Počet vstupenek do "FUN WATER PARK"'
              v-model="order.pocetVodnichSvetu"
              required
              :rules="[requiredRulle]"
              :suffix="cenaZaVodniSvety | formatPrice"
              mask="###"
              :disabled="!isDateValid"
              @change="this.vodniSvetChange"
            ></v-text-field>
            <v-text-field
              label="Počet vest"
              v-model="order.pocetVest"
              required
              :rules="[requiredRulle, v => checkForAviableVest(v) || 'Omlouváme se, ale tolik vest na tuto dobu již nemáme :-)', v => checkForAviableVestVodniSvet(v) || 'Počet objednaných vest musí být minimálně shodný s počtem objednaných vstupenek do FUN WATER PARK.']"
              suffix="Zdarma"
              mask="###"
              :disabled="!isDateValid"
              ref="pocetVestFiedl"
            ></v-text-field>
            <v-text-field
              v-if="!isSluzbaAkce"
              label='Počet šlapadel'
              v-model="order.pocetSlapadel"
              required
              :rules="[requiredRulle, v => checkForAviableSlapadla(v) || 'Omlouváme se, ale tolik šlapadel na tuto dobu již nemáme :-)', v => Number(v) >= 0 || 'Počet objednaných šlapadel nesmí být záporný']"
              :suffix="cenaZaSlapadla | formatPrice"
              mask="###"
              :disabled="!isDateValid"
            ></v-text-field>
            <v-text-field
              label='Počet kanoí'
              v-model="order.pocetKanoi"
              required
              :rules="[requiredRulle, v => checkForAviableKanoe(v) || 'Omlouváme se, ale tolik kanoí na tuto dobu již nemáme :-)', v => Number(v) >= 0 || 'Počet objednaných kanoi nesmí být záporný']"
              :suffix="cenaZaKanoe | formatPrice"
              mask="###"
              :disabled="!isDateValid"
            ></v-text-field>
            <v-text-field
              v-if="!isSluzbaAkce"
              label='Počet lodí s pohonem pro 4 - 5 osob'
              v-model="order.pocetLodi"
              required
              :rules="[requiredRulle, v => checkForAviableLode(v) || 'Omlouváme se, ale tolik lodí na tuto dobu již nemáme :-)', v => Number(v) >= 0 || 'Počet objednaných lodí nesmí být záporný']"
              :suffix="cenaZaLode | formatPrice"
              mask="###"
              :disabled="!isDateValid"
            ></v-text-field>
            <v-text-field
              v-if="!isSluzbaAkce"
              label='Počet koloběžek'
              v-model="order.pocetKolobezek"
              required
              :rules="[requiredRulle, v => checkForAviableKolobezky(v) || 'Omlouváme se, ale tolik koloběžek na tuto dobu již nemáme :-)', v => Number(v) >= 0 || 'Počet objednaných koloběžek nesmí být záporný']"
              :suffix="cenaZaKolobezky | formatPrice"
              mask="###"
              :disabled="!isDateValid"
            ></v-text-field>
            <v-checkbox
              v-if="moznostDopravyKolobezka"
              label="Mám zájem o dopravu na koloběžce"
              v-model="order.dopravaKolobezka"
              color="primary"
              value="1"
              hide-details
            ></v-checkbox>
<!--            <div v-if="order.doprava && popisDopravy" v-html="popisDopravy"></div>-->
            <v-layout row wrap class="mt-3">
              <v-flex xs12 sm6 class="pr-2">
                <v-dialog
                  v-if="moznostDopravyKolobezka && order.dopravaKolobezka"
                  ref="dialog5"
                  persistent
                  v-model="modal5"
                  lazy
                  full-width
                  width="290px"
                  :return-value.sync="order.dopravaKolobezkaOd"
                >
                  <v-text-field
                    v-if="moznostDopravyKolobezka && order.dopravaKolobezka"
                    slot="activator"
                    label="Čas vyzvednutí koloběžek"
                    v-model="order.dopravaKolobezkaOd"
                    prepend-icon="access_time"
                    readonly
                    :rules="[requiredRulle]"
                    required
                    @input="refreshSkladoveZasobyAkceKolobezky"
                  ></v-text-field>
                  <v-time-picker-override
                    v-if="moznostDopravyKolobezka && order.dopravaKolobezka"
                    v-model="order.dopravaKolobezkaOd"
                    format="24hr"
                    :allowed-hours="getAllowedHoursAkceKolobezky"
                    :allowed-minutes="getAllowedMinutes"
                    actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal5 = false">Zrušit</v-btn>
                    <v-btn flat color="primary"
                           @click="$refs.dialog5.save(order.dopravaKolobezkaOd);refreshSkladoveZasobyAkceKolobezky()">
                      Potvrdit
                    </v-btn>
                  </v-time-picker-override>
                </v-dialog>
              </v-flex>
              <v-flex xs12 sm6 class="pr-2">
                <v-text-field
                  v-if="moznostDopravyKolobezka && order.dopravaKolobezka"
                  label="Počet koloběžek"
                  v-model="order.pocetDopravKolobezka"
                  required
                  :suffix="cenaZaDopravuKolobezka ? (cenaZaDopravuKolobezka | formatPrice) + ' Kč' : 'Zdarma'"
                  :rules="[requiredRulle, v => checkForAviableShippingKolobezka(v) || 'Omlouváme se, ale tolik volných koloběžek již nemáme :-)', v => !cenaZaDopravuKolobezka || Number(v) > 0 || 'Počet objednaných koloběžek musí být větší než 0']"
                  mask="###"
                  :disabled="!isDateKolobezkyAkceValid"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-checkbox
              v-if="moznostDopravy"
              label="Mám zájem o dopravu"
              v-model="order.doprava"
              color="primary"
              value="1"
              hide-details
            ></v-checkbox>
            <div v-if="order.doprava && popisDopravy" v-html="popisDopravy"></div>
            <v-text-field
              v-if="moznostDopravy && order.doprava"
              label="Počet dopravovaných osob"
              v-model="order.pocetDoprav"
              required
              :suffix="cenaZaDopravu ? (cenaZaDopravu | formatPrice) + ' Kč' : 'Zdarma'"
              :rules="[requiredRulle, v => checkForAviableShipping(v) || 'Omlouváme se, ale tolik volných míst již nemáme :-)', v => !cenaZaDopravu || Number(v) > 0 || 'Počet objednaných doprav musí být větší než 0']"
              mask="###"
            ></v-text-field>
            <!--<p v-if="order.doprava">Zbývající počet doprav: {{ dopravaVolnaMista - order.pocetDoprav }}</p>-->
            <div class="celkova-cena"><span>Celková cena:</span> {{ cenaCelkem | formatPrice }}</div>
            <v-layout row wrap fill-height align-center justify-space-between>
              <v-btn
                class="ma-0"
                color="primary"
                @click="back"
              >Zpět
              </v-btn>

              <v-btn
                class="ma-0"
                :disabled="!valid || !checkForNotEmptyOrder()"
                color="primary"
                @click="next"
              >Pokračovat
              </v-btn>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import Footer from '@/components/Footer'
  import {mapGetters} from 'vuex'
  import moment from 'moment-timezone'
  import {getVolnaMistaAkce, getVolnaMistaHlavniSluzba, getCenyHlavniSluzba, getAkceKolobezkyKapacita} from '../api/api'
  import VTimePickerOverride from '../overides/VTimePickerOverride'
  import VDatePickerOverride from '../overides/VDatePickerOverride'
  import {init} from '@/api/api';

  export default {
    components: {
      'footer-nav': Footer,
      VTimePickerOverride,
      VDatePickerOverride

    },
    props: ['actionID', 'dateTimeFrom', 'prevRoute'],
    data() {
      return {
        order: {
          cenaCelkem: 0,
          datumKonani: '',
          datumKonaniDo: '',
          konaniOd: null,
          konaniDo: null,
          mistoVyzvednuti: '',
          mistoOdevzdani: '',
          pocetPrken: '',
          pocetVest: '',
          pocetVodnichSvetu: '',
          pocetSlapadel: '',
          pocetKanoi: '',
          pocetLodi: '',
          pocetKolobezek: '',
          pocetPadel: '',
          doprava: false,
          dopravaKolobezka: false,
          dopravaKolobezkaOd: null,
          pocetDoprav: '',
          pocetDopravKolobezka: '',
        },
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false,
        valid: true,
        volnaMista: 0,
        dopravaVolnaMista: 0,
        vestyVolnaMista: 0,
        dopravaKolobezkaVolnaMista: 0,
        slevy: [],
        slevyKanoe: [],
        cenaDopravyKolobezka: 0,
        cenaZaPrknoRezervace: 0,
        cenaZaVodniSvetRezervace: 0,
        cenaZaSlapadlo: 0,
        cenaZaKanoiRezervace: 0,
        cenaZaLodRezervace: 0,
        cenaZaKolobezku: 0,
        moznostDopravy: false,
        moznostDopravyKolobezka: false,
        cenaDopravyOsoba: 0,
        popisDopravy: '',
        requiredRulle: v => !!v || 'Položka je povinná',
      }
    },
    methods: {
      afterMounted() {
        window.moment = moment;
        this.order = Object.assign(this.order, this.getOrder);

        this.order.pocetPrken = '';
        this.order.pocetVest = '';
        this.order.pocetVodnichSvetu = '';
        this.order.pocetSlapadel = '';
        this.order.pocetKanoi = '';
        this.order.pocetLodi = '';
        this.order.pocetKolobezek = '';

        if (this.isSluzbaAkce) {

          this.$store.commit('swapMultiDayRezervation', true);
          this.order.datumKonani = moment.utc(this.selectedService.field_akce_datum_od_do_value).tz('Europe/Prague').format('YYYY-MM-DD');
          this.order.datumKonaniDo = moment.utc(this.selectedService.field_akce_datum_od_do_value2).tz('Europe/Prague').format('YYYY-MM-DD');
          this.order.konaniOd = moment.utc(this.selectedService.field_akce_datum_od_do_value).tz('Europe/Prague').format('HH:mm');
          this.order.konaniDo = moment.utc(this.selectedService.field_akce_datum_od_do_value2).tz('Europe/Prague').format('HH:mm');
          this.order.mistoVyzvednuti = this.selectedService.misto_zacatku;
          this.order.mistoOdevzdani = this.selectedService.misto_konce;
          this.getVolnaMistaAkce(this.sluzba.id).then(response => {
            const data = response.data.data;


            if (data.moznost_dopravy) {
              this.moznostDopravy = Number(data.moznost_dopravy);
              this.cenaDopravyOsoba = data.cena_za_dopravu;
              this.dopravaVolnaMista = data.doprava_volna_mista;
              this.popisDopravy = data.doprava_popis;
            }

            if (data.moznost_dopravy_kolobezka) {
              this.moznostDopravyKolobezka = Number(data.moznost_dopravy_kolobezka);
              // this.cenaDopravyKolobezka = data.cena_za_dopravu_kolobezka;
              // this.dopravaKolobezkaVolnaMista = data.doprava_volna_mista_kolobezka;
            }

            this.volnaMista = data.volna_mista;
            this.vestyVolnaMista = data.vesty_volna_mista;
            this.kanoeVolnaMista = data.kanoe_volna_mista;
            this.lodeVolnaMista = data.lode_volna_mista;
            this.slevy = data.slevy ? data.slevy : [];
            this.slevyKanoe = data.slevyKanoe ? data.slevyKanoe : [];

            this.order.pocetPrken = this.getOrder.pocetPrken;
            this.order.pocetVest = this.getOrder.pocetVest;
            this.order.pocetKanoi = this.getOrder.pocetKanoi;
            this.order.pocetLodi = this.getOrder.pocetLodi;

            if (!this.order.pocetPrken) {
              this.order.pocetPrken = 0;
            }

            if (!this.order.pocetVest) {
              this.order.pocetVest = 0;
            }

            if (!this.order.pocetKanoi) {
              this.order.pocetKanoi = 0;
            }

            if (!this.order.pocetLodi) {
              this.order.pocetLodi = 0;
            }
          });

          this.refreshSkladoveZasobyAkceKolobezky();
        } else {
          const defaultPobocka = this.getPobocky.find(item => (this.getStore() == 24) ? item.value == 25 : item.value == 22);

          if (defaultPobocka) {
            this.order.mistoVyzvednuti = defaultPobocka.text;
            this.order.mistoOdevzdani = defaultPobocka.text;
          }

          this.order.datumKonani = this.$store.getters.getDatumKonaniOd ? this.$store.getters.getDatumKonaniOd : moment.utc().tz('Europe/Prague').format('YYYY-MM-DD');
          this.order.datumKonaniDo = this.$store.getters.getDatumKonaniDo ? this.$store.getters.getDatumKonaniDo : moment.utc().tz('Europe/Prague').format('YYYY-MM-DD');

          if (typeof this.dateTimeFrom !== "undefined" && this.dateTimeFrom) {

            let m = moment(this.dateTimeFrom);

            this.order.datumKonani = m.format('YYYY-MM-DD');
            this.order.datumKonaniDo = m.format('YYYY-MM-DD');

            this.order.konaniOd = m.format('HH:mm');
            this.order.konaniDo = m.add('h', 1).format('HH:mm');
          }
//                this.getCenyHlavniSluzba().then(response => {
//                    const data = response.data.data;
//                    this.slevy = data.slevy ? data.slevy : [];
//                });
          this.refreshSkladoveZasoby();
        }
      },
      back() {
        this.$store.commit('setActualStep', 1);
        this.$router.push({name: this.prevRoute});
      },
      next() {
        this.order.cenaZaPrkna = this.cenaZaPrkna;
        this.order.cenaZaKanoe = this.cenaZaKanoe;
        this.order.cenaZaDopravuKolobezka = this.cenaZaDopravuKolobezka;
        this.order.cenaZaDopravu = this.cenaZaDopravu;
        this.order.cenaCelkem = this.cenaCelkem;

        this.$store.dispatch('setOrder', this.order).then(() => {
          this.$router.push('step-3')
        })
      },
      getAllowedHours(val) {
        return val >= 8 && val <= 20;
      },
      getAllowedHoursAkceKolobezky(val) {
        let maxHours = moment.tz(this.order.datumKonani + ' ' + this.order.konaniOd, 'Europe/Prague').locale('cs').format('HH');
        return val >= 8 && val <= (maxHours - 1);
      },
      checkPadlleboradStore(val) {
        return val && Number(val) <= this.volnaMista;
      },
      checkForAviableShipping(val) {
        return val && Number(val) <= this.dopravaVolnaMista;
      },
      checkForAviableShippingKolobezka(val) {
        return val && Number(val) <= this.dopravaKolobezkaVolnaMista;
      },
      checkForAviableVest(val) {
        return val && Number(val) <= this.vestyVolnaMista;
      },
      checkForAviableSlapadla(val) {
        return val && Number(val) <= this.slapadlaVolnaMista;
      },
      checkForAviableKanoe(val) {
        return val && Number(val) <= this.kanoeVolnaMista;
      },
      checkForAviableLode(val) {
        return val && Number(val) <= this.lodeVolnaMista;
      },
      checkForAviableKolobezky(val) {
        return val && Number(val) <= this.kolobezkyVolnaMista;
      },
        checkForNotEmptyOrder() {
        return this.order.pocetPrken > 0 || this.order.pocetVodnichSvetu > 0 || this.order.pocetSlapadel > 0 || this.order.pocetKanoi > 0 || this.order.pocetLodi > 0 || this.order.pocetKolobezek > 0;
      },
      checkDateFrom(val) {
        return !val || !moment(val, 'DD. MM. YYYY').isValid() ? true : moment(val, 'DD. MM. YYYY').isAfter(moment().subtract(1, 'd'));
      },
      checkDateTo(val) {
        return !val || !moment(val, 'DD. MM. YYYY').isValid() ? true : moment(val, 'DD. MM. YYYY').isAfter(moment().subtract(1, 'd'));
      },
      checkTimeFrom(val) {

        const isToday = this.order.datumKonani === moment().format('YYYY-MM-DD');

        const eqDates = this.order.datumKonaniDo === this.order.datumKonani;

        const timeFrom = moment(val, 'HH:mm');

        return !val || !timeFrom.isValid() ? true : isToday && timeFrom.format('HH:mm') < moment().format('HH:mm') ? 'Čas nesmí být v minulosti' : eqDates && this.order.konaniDo && timeFrom.format('HH:mm') >= this.order.konaniDo ? 'Čas musí být menší než čas do' : true;
      },
      checkTimeTo(val) {

        const isToday = this.order.datumKonaniDo === moment().format('YYYY-MM-DD');

        const eqDates = this.order.datumKonaniDo === this.order.datumKonani;

        const timeFrom = moment(val, 'HH:mm');

        return !val || !timeFrom.isValid() ? true : isToday && timeFrom.format('HH:mm') < moment().format('HH:mm') ? 'Čas nesmí být v minulosti' : eqDates && this.order.konaniOd && timeFrom.format('HH:mm') <= this.order.konaniOd ? 'Čas musí být větší než čas od' : true;
      },
        checkForAviableVestVodniSvet(val) {
            return Boolean(this.multiDayRezervation || (val && Number(val) >= Number(this.order.pocetVodnichSvetu)));
        },
      refreshSkladoveZasoby() {

        if (this.isSluzbaAkce || !this.isDateValid) {
          return;
        }

        const params = {
          'from': moment.tz(this.order.datumKonani + ' ' + this.order.konaniOd, 'Europe/Prague').utc().format('YYYY-MM-DD HH:mm'),
          'to': moment.tz(this.order.datumKonaniDo + ' ' + this.order.konaniDo, 'Europe/Prague').utc().format('YYYY-MM-DD HH:mm'),
        }

        this.getVolnaMistaHlavniSluzba(params).then(response => {
          const data = response.data.data;

          this.volnaMista = data.sklady_prkna;
          this.vestyVolnaMista = data.sklady_vesty;
          this.slapadlaVolnaMista = data.sklady_slapadla;
          this.kanoeVolnaMista = data.sklady_kanoe;
          this.lodeVolnaMista = data.sklady_lode;
          this.kolobezkyVolnaMista = data.sklady_kolobezky;
          this.cenaZaPrknoRezervace = data.cena_za_prkno;
          this.cenaZaVodniSvetRezervace = data.cena_za_vodni_svet;
          this.cenaZaSlapadlo = data.cena_za_slapadla;
          this.cenaZaKanoiRezervace = data.cena_za_kanoe;
          this.cenaZaLodRezervace = data.cena_za_lode;
          this.cenaZaKolobezku = data.cena_za_kolobezky;

          this.order.pocetPrken = this.getOrder.pocetPrken;
          this.order.pocetVest = this.getOrder.pocetVest;
          this.order.pocetVodnichSvetu = this.getOrder.pocetVodnichSvetu;
          this.order.pocetSlapadel = this.getOrder.pocetSlapadel;
          this.order.pocetKanoi = this.getOrder.pocetKanoi;
          this.order.pocetLodi = this.getOrder.pocetLodi;
          this.order.pocetKolobezek = this.getOrder.pocetKolobezek;

          if (!this.order.pocetPrken) {
            this.order.pocetPrken = "0";
          }

          if (!this.order.pocetVest) {
            this.order.pocetVest = "0";
          }

          if (!this.order.pocetVodnichSvetu) {
            this.order.pocetVodnichSvetu = "0";
          }

          if (!this.order.pocetSlapadel) {
            this.order.pocetSlapadel = "0";
          }

          if (!this.order.pocetKanoi) {
            this.order.pocetKanoi = "0";
          }

          if (!this.order.pocetLodi) {
            this.order.pocetLodi = "0";
          }

          if (!this.order.pocetKolobezek) {
            this.order.pocetKolobezek = "0";
          }

          this.$refs.form.validate();
        });
      },
      refreshSkladoveZasobyAkceKolobezky() {
        const params = {
          'from': moment.tz(this.order.datumKonani + ' ' + this.order.dopravaKolobezkaOd, 'Europe/Prague').utc().format('YYYY-MM-DD HH:mm'),
          'to': moment.tz(this.order.datumKonani + ' ' + this.order.konaniOd, 'Europe/Prague').utc().format('YYYY-MM-DD HH:mm'),
          'action': this.sluzba.id,
        }

        this.getAkceKolobezkyKapacita(params).then(response => {
          const data = response.data.data;

          this.dopravaKolobezkaVolnaMista = data.sklady_kolobezky;
          this.cenaDopravyKolobezka = data.cena_za_dopravu_kolobezka;

          if (!this.order.pocetDopravKolobezka) {
            this.order.pocetDopravKolobezka = "0";
          }

          this.$refs.form.validate();
        });
      },
      formatSubHeaderDate(originalDate) {
        return moment(originalDate).format('MM. YYYY');
      },
      formatHeaderDate(originalDate) {
        return moment(originalDate).format('DD. MM. YYYY');
      },
      formatMonths(originalMonth) {
        // console.log(originalMonth);
        return moment(originalMonth).locale('cs').format('MMM');
      },
      getAllowedMinutes(val) {
        return val === 0;
      },
      multiDayRezervationChange() {
        this.order.datumKonaniDo = this.order.datumKonani;
        this.refreshSkladoveZasoby();
      },
        vodniSvetChange(val) {
            if (parseInt(this.order.pocetVest) < parseInt(val)) {
                this.order.pocetVest = val;
            }
            this.$refs.pocetVestFiedl.validate();
        },
      getStore() {
        if (window.location.hostname === 'rezervace.sup-pardubice.cz') {
          return 23;
        } else if (window.location.hostname === 'rezervace.sup-hradec.cz') {
          return 24;
        } else {
          return $cookies.isKey("STORE_COOKIE") && $cookies.get("STORE_COOKIE") === 'hk' ? 24 : 23;
        }
      },
      // formatDays(originalDay){
      //   // console.log(originalDay);
      //   return originalDay;
      // },
      getVolnaMistaAkce,
      getVolnaMistaHlavniSluzba,
      getCenyHlavniSluzba,
      getAkceKolobezkyKapacita

    },
    computed: {
      ...mapGetters([
        'selectedService',
        'sluzba',
        'getOrder',
        'getPobockyOptions',
        'getMultiDayRezervation',
        'getPobocky',
      ]),
      dateFromFormatedOutput() {
        return this.order.datumKonani ? moment(this.order.datumKonani).format('DD. MM. YYYY') : '';
      },
      dateToFormatedOutput() {
        return this.order.datumKonaniDo ? moment(this.order.datumKonaniDo).format('DD. MM. YYYY') : '';
      },
      multiDayRezervation: {
        get() {
          return this.getMultiDayRezervation;
        },
        set(val) {
          this.multiDayRezervationChange();
          this.$store.commit('swapMultiDayRezervation', val);
          // if (!Boolean(this.multiDayRezervation) && parseInt(this.order.pocetVodnichSvetu) > 0) {
          //   console.log("in");
          //   this.order.pocetVest = this.order.pocetVodnichSvetu;
          // }
        }
      },
      multiDayReyervationSwapButtonText() {
        return this.getMultiDayRezervation ? 'Rezervuji na jeden den' : 'Rezervuji na více dní';
      },
      isDateValid() {
        return this.order.datumKonani && this.order.datumKonaniDo && this.order.konaniOd && this.order.konaniDo;
      },
      isDateKolobezkyAkceValid() {
        return this.order.dopravaKolobezkaOd;
      },
      cenaZaPrknoAkce() {

        const slevaProAkci = item => Number(item.min_pocet) <= Number(this.order.pocetPrken);

        let slevaItem = this.slevy.find(slevaProAkci);

        return slevaItem ? slevaItem.cena : this.selectedService.cena_za_prkno;
      },
      cenaZaKanoiAkce() {
        const slevaProAkci = item => Number(item.min_pocet) <= Number(this.order.pocetKanoi);
        let slevaItem = this.slevyKanoe.find(slevaProAkci);

        return slevaItem ? slevaItem.cena : this.selectedService.cena_za_kanoi;
      },
      cenaZaKolobezkaAkce() {
        // let from = moment.tz(this.order.datumKonani + ' ' + this.order.konaniOd, 'Europe/Prague')
        // let to = moment.tz(this.order.datumKonaniDo + ' ' + this.order.konaniDo, 'Europe/Prague')
        //
        // let hours = to.diff(from, 'hours');
        //
        // const slevaKolobezkyProAkci = item => Number(item.max_pocet_hodin) <= Number(hours);
        // let slevaItem = this.cenaDopravyKolobezka.find(slevaKolobezkyProAkci);

        return this.cenaDopravyKolobezka ? this.cenaDopravyKolobezka : 0;
      },
//            cenaZaPrknoRezervace() {
//
//                const delkaRezervace = moment(this.order.datumKonaniDo + ' ' + this.order.konaniDo).diff(moment(this.order.datumKonani + ' ' + this.order.konaniOd), 'hours');
//
//                const slevaProRegistraci = item => Number(delkaRezervace) <= Number(item.max_pocet_hodin);
//
//                let slevaItem = this.slevy.find(slevaProRegistraci);
//
//                const pocetDni = Math.ceil(delkaRezervace / 24.0);
//
//                return slevaItem ? slevaItem.cena : pocetDni * this.selectedService.cena_za_prkno;
//                return this.cenaZaPrknoRezervace;
//            },
      cenaZaPrkno() {
        return this.isSluzbaAkce ? this.cenaZaPrknoAkce : this.cenaZaPrknoRezervace;
      },
      cenaZaKanoi() {
        return this.isSluzbaAkce ? this.cenaZaKanoiAkce : this.cenaZaKanoiRezervace;
      },
      cenaZaLod() {
        return this.cenaZaLodRezervace;
      },
      cenaZaPrkna() {
        return this.order.pocetPrken * this.cenaZaPrkno;
      },
      cenaZaVodniSvet() {
        return this.cenaZaVodniSvetRezervace;
      },
      cenaZaVodniSvety() {
        return Math.max(this.order.pocetVodnichSvetu  - this.order.pocetPrken, 0) * this.cenaZaVodniSvet;
      },
      cenaZaSlapadla() {
        return this.order.pocetSlapadel * this.cenaZaSlapadlo;
      },
      cenaZaKanoe() {
        return this.order.pocetKanoi * this.cenaZaKanoi;
      },
      cenaZaLode() {
        return this.order.pocetLodi * this.cenaZaLod;
      },
      cenaZaKolobezky() {
        return this.order.pocetKolobezek * this.cenaZaKolobezku;
      },
      cenaZaDopravu() {
        return this.cenaDopravyOsoba ? this.cenaDopravyOsoba * this.order.pocetDoprav : 0;
      },
      cenaZaDopravuKolobezka() {
        return this.cenaZaKolobezkaAkce ? this.cenaZaKolobezkaAkce * this.order.pocetDopravKolobezka : 0;
      },
      cenaCelkem() {
        let cenaCelkem = this.cenaZaPrkna;
        cenaCelkem += this.cenaZaSlapadla;
        cenaCelkem += this.cenaZaKanoe;
        cenaCelkem += this.cenaZaLode;
        cenaCelkem += this.cenaZaKolobezky;

        if (this.order.doprava) {
          cenaCelkem += this.cenaZaDopravu;
        }

        if (this.order.dopravaKolobezka) {
          cenaCelkem += this.cenaZaDopravuKolobezka;
        }

        if (this.order.pocetVodnichSvetu && !this.multiDayRezervation){
          cenaCelkem += this.cenaZaVodniSvety;
        }

        return cenaCelkem;
      },
      isSluzbaAkce() {
        return this.sluzba.typ == 'action';
      }
    },
    mounted() {
      if(this.actionID) {
        init(-1).then(response => {
          this.$store.commit('setActionsList', response.data.data.actions);
          this.$store.commit('setPobockyOptions', response.data.data.pobocky_options);

          this.$store.dispatch('setService', this.actionID).then(() => {
            this.afterMounted();
          })
        })
      } else {
        this.afterMounted();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Step2.vue